import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=64a8f1ba&scoped=true&"
import script from "./SelectInput.vue?vue&type=script&lang=js&"
export * from "./SelectInput.vue?vue&type=script&lang=js&"
import style0 from "./SelectInput.vue?vue&type=style&index=0&id=64a8f1ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a8f1ba",
  null
  
)

export default component.exports